import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 20,
};

export const mEditorsListTableControllerSlice = createSlice({
    name: 'mEditorsListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const { changeCurrentPage } = mEditorsListTableControllerSlice.actions;

export default mEditorsListTableControllerSlice.reducer;